import {
  InfoContentWrapper,
  InfoParagraph,
  LangWrapper,
  LangIcon,
} from "./style";

export const InfoSection = ({
  data,
  currentLang,
  languages,
  onLangIconClick = () => {},
}) => (
  <InfoContentWrapper>
    <img
      src={
        window.WP_PATH +
        "wp-content/uploads/2023/03/COMANAGE-main-color-negative-1.png"
      }
    />
    <LangWrapper>
      {languages.map((data) => (
        <LangIcon
          key={data.icon.url}
          style={{ backgroundImage: `url(${data.icon.url})` }}
          onClick={() => {
            onLangIconClick(data);
          }}
        />
      ))}
    </LangWrapper>
    <InfoParagraph dangerouslySetInnerHTML={{ __html: data.body }} />
  </InfoContentWrapper>
);
